import { createApp } from 'vue';
import App from './App.vue';
import './styles/index.css';
import '@splidejs/vue-splide/css';
import router from './router';
import store from './store';
import directive from './directive';
import VueSplide from '@splidejs/vue-splide';
import VueAmap, { initAMapApiLoader } from '@vuemap/vue-amap';
import '@vuemap/vue-amap/dist/style.css';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'element-plus/dist/index.css';
import 'highlight.js/styles/atom-one-light.css';
import './permission';
import initWebTracing from './plugins/web-tracing';

const app = createApp(App);

directive(app);

initAMapApiLoader({
  key: '89433d5b46ce06e53ebee8107f19a052',
  securityJsCode: 'bec6b8e1c374c133bce3d1d95859d1f8',
});

app
  .use(router)
  .use(VueAmap)
  .use(store)
  .use(VueSplide)
  .use(ElementPlus, { locale: zhCn })
  .mount('#root');

if (import.meta.env.VITE_APP_WEB_TRACING_OPEN === '1') {
  setTimeout(() => {
    initWebTracing(app);
  });
}
